import { Helmet } from "react-helmet-async";
import Screen from "../../Layouts/Screen/Screen";
import "./style.css"
import { CheckCircle, Filter, Search, UserMinus, Users, X } from "react-feather";
import { useCallback, useEffect, useRef, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import axios from "axios";
import { useAuth } from "../../../global-components/src";
import { useMessage } from "../../../global-components/src";
import { Post, Community } from "../../../types";
import PostList from "../../../components/Post/PostList";
import UserSearch from "./User/User";
import debounce from 'lodash/debounce';
import ItemList from "../../../components/ItemList/ItemList";
import { errorMessage } from "../../../utils/TextManagerTwo";
import ModalPostLikes from "../../Posts/PostLikes/ModalPostLikes";
import { BUCKET_PACOCA_URL, PACOCA_API_URL } from "../../../global-components/src/utils/vars";
import { getImagePathBucketPacoca } from "../../../global-components/src/utils/utils";
import { UserSearchLoadin } from "./User/UserSearchLoading";
import ModalCommentsBottom from "../../../components/Modals/comments/comments-bottom";
import ModalComments from "../../../components/Modals/comments/modal-comments";
import Cookies from "js-cookie";
import { User } from "../../../global-components/src/types";
import { t } from "i18next";
import { LIMIT_REQUEST_FOLLOWERS } from "../../../utils/vars";
import { disintegrate, toggleAskew, triggerBarrelRoll, triggerGravity, triggerShake } from "./easter-eggs/easter-eggs";
import { resetEasterEggs, toggleUpsideDown, triggerAvadaKedavra, triggerLeviosa, triggerLumos, triggerMatrix, triggerNox, triggerParty, triggerPatronus, triggerSnow } from "./easter-eggs/easter-eggs-themes";
import { EggId, resolveEggId } from "./easter-eggs/easter-egg-aliases";
import MarioCoin from "./easter-eggs/mario-coin";
import BottomSheet from "../../../components/bottom-sheet/bottom-sheet";

type EasterEgg = {
    action: () => void;
    icon?: string;
};

/* ─── helpers ─────────────────────────────────────────────── */
const isMobile = () => window.innerWidth <= 850;

function extractFilterTokens(str: string): string[] {
    return str
        .split(/\s+/)
        .map(t => t.trim())
        .filter(t => t.startsWith(":"));
}

function extractCleanText(str: string): string {
    return str
        .split(/\s+/)
        .map(t => t.trim())
        .filter(t => t.length > 0 && !t.startsWith(":"))
        .join(" ");
}

function combineSearchAndFilters(cleanText: string, filterTokens: string[]): string {
    const parts: string[] = [];
    const trimmed = cleanText.trim();
    if (trimmed) parts.push(trimmed);
    parts.push(...filterTokens.filter(Boolean));
    return parts.join(" ");
}

function getFilterParam(str: string, key: string): string {
    const token = str
        .split(/\s+/)
        .find(t => t.startsWith(`:${key}=`));
    if (!token) return "";
    return token.substring(`:${key}=`.length);
}

function hasFilterFlag(str: string, flag: string): boolean {
    return str.split(/\s+/).includes(flag);
}

const SearchScreen = () => {
    const title = window.innerWidth > 850 ? t("settings.title") : ""
    const [searchParams, setSearchParams] = useSearchParams();
    const initialTermo = searchParams.get("termo") || "";
    const [termo, setTermo] = useState(initialTermo);
    const [termoLimpo, setTermoLimpo] = useState(extractCleanText(initialTermo));
    const [termoSearch, setTermoSearch] = useState(initialTermo);
    const [typeSeach, setTypeSeach] = useState(searchParams.get("tipoFeed") || "user");
    const [loading, setLoading] = useState(false);
    const [users, setUsers] = useState<User[] | null>(null);
    const [posts, setPosts] = useState<Post[]>([]);
    const [communities, setCommunities] = useState<Community[]>([]);
    const [filter, setFilters] = useState<any>({});
    const { token } = useAuth();
    const { setMessage } = useMessage();
    const navigate = useNavigate();
    const [loadingTermo, setLoadingTermo] = useState(false);
    const [dataNotFound, setDataNotFound] = useState(false);
    const [showModalLikes, setShowModalLikes] = useState(false);
    const [showModalComments, setShowModalComments] = useState(false);
    const [idPostSelected, setIdPostSelected] = useState<number | null>(null);
    const [imgPath, setImgPath] = useState("");
    const [isDropdownVisible, setDropdownVisible] = useState(false);
    const [coins, setCoins] = useState<number[]>([]);
    // side-panel animation state (desktop)
    const [panelEntering, setPanelEntering] = useState(false);
    const [panelRendered, setPanelRendered] = useState(false);
    const snapping = useRef(false);
    let coinId = 0;

    function spawnCoin() {
        setCoins(prev => [...prev, coinId++]);
    }
    function removeCoin(id: number) {
        setCoins(prev => prev.filter(c => c !== id));
    }

    // keys are canonical ids; the terms that trigger them (any language) live in easter-egg-aliases.ts
    const easterEggs: Record<EggId, EasterEgg> = {
        "67": { action: () => triggerShake() },
        thanos: { action: () => thanosSnap(), icon: "thanos_idle.png" },
        nox: { action: () => triggerNox() },
        lumos: { action: () => triggerLumos() },
        leviosa: { action: () => triggerLeviosa() },
        patronus: { action: () => triggerPatronus() },
        avada: { action: () => triggerAvadaKedavra() },
        matrix: { action: () => triggerMatrix() },
        snow: { action: () => triggerSnow() },
        party: { action: () => triggerParty() },
        upsideDown: { action: () => toggleUpsideDown() },
        barrelRoll: { action: () => triggerBarrelRoll() },
        askew: { action: () => toggleAskew() },
        gravity: { action: () => triggerGravity() },
        mario: { action: () => spawnCoin(), icon: "mario.png" },
    };
    const currentEggId = resolveEggId(termoLimpo);
    const currentEgg = currentEggId ? easterEggs[currentEggId] : undefined;
    
    /** Picks (randomly) the indexes of the half of the list that will turn to dust. */
    function pickVictims(length: number): Set<number> {
        const indexes = Array.from({ length }, (_, i) => i).sort(() => Math.random() - 0.5);
        const count = length === 1 ? (Math.random() < 0.5 ? 1 : 0) : Math.floor(length / 2);
        return new Set(indexes.slice(0, count));
    }

    async function thanosSnap() {
        if (snapping.current) return;

        const root = document.querySelector(".content-screen");
        if (!root) return;

        const isPosts = typeSeach == "post";
        const length = isPosts ? posts.length : typeSeach == "user" ? (users?.length ?? 0) : communities.length;
        if (!length) return;

        const victims = pickVictims(length);
        const removeVictims = <T,>(list: T[]) => list.filter((_, i) => !victims.has(i));

        // Visible DOM elements that belong to a victim
        const targets: HTMLElement[] = [];
        if (isPosts) {
            root.querySelectorAll<HTMLElement>(".card-post").forEach(el => {
                const index = Number(el.closest("[data-item-index]")?.getAttribute("data-item-index"));
                if (victims.has(index)) targets.push(el);
            });
        } else {
            root.querySelectorAll<HTMLElement>(".row-user").forEach((el, index) => {
                if (victims.has(index)) targets.push(el);
            });
        }

        snapping.current = true;
        const cleanup = await disintegrate(targets);

        if (isPosts) setPosts(removeVictims);
        else if (typeSeach == "user") setUsers(prev => prev ? removeVictims(prev) : prev);
        else setCommunities(removeVictims);

        requestAnimationFrame(() => {
            cleanup();
            snapping.current = false;
        });
    }

    /* ── dropdown / panel open + close ──────────────────────── */
    const openFilter = (event: React.MouseEvent) => {
        event.preventDefault();
        if (isMobile()) {
            setDropdownVisible(true);
        } else {
            setPanelRendered(true);
            requestAnimationFrame(() => setPanelEntering(true));
        }
    };

    const closeFilter = () => {
        if (isMobile()) {
            setDropdownVisible(false);
        } else {
            setPanelEntering(false);
            setTimeout(() => setPanelRendered(false), 240);
        }
    };

    const changeTypeSearch = (type: string) => {
        setLoading(false);
        setUsers(null);
        if (type !== typeSeach) {
            setTypeSeach(type);
        } else {
            handleSearch();
        }
    };

    useEffect(() => {
        setTermoLimpo(extractCleanText(termo));
    }, [termo]);

    // persistent easter eggs (nox, askew, upside down...) must not outlive this screen
    useEffect(() => resetEasterEggs, []);

    useEffect(() => {
        closeFilter();
        const newParams = new URLSearchParams(searchParams);
        newParams.set("tipoFeed", typeSeach);
        setSearchParams(newParams, { replace: true });
    }, [typeSeach]);

    useEffect(() => {
        const handleModalClose = () => {
            setShowModalLikes(false);
            setShowModalComments(false);
            setIdPostSelected(null);
        };
    
        const modalLikesElement = document.getElementById("modal-likes");
        const modalCommentsElement = document.getElementById("modal-comments");

        if (modalLikesElement)
            modalLikesElement.addEventListener("hidden.bs.modal", handleModalClose);

        if (modalCommentsElement)
            modalCommentsElement.addEventListener("hidden.bs.modal", handleModalClose);
    
        return () => {
            if (modalLikesElement)
                modalLikesElement.removeEventListener("hidden.bs.modal", handleModalClose);

            if (modalCommentsElement)
                modalCommentsElement.removeEventListener("hidden.bs.modal", handleModalClose);
        };
    }, []);

    const onCloseModals = () => {
        setShowModalLikes(false);
        setShowModalComments(false);
        setIdPostSelected(null);
    };

    function parseFiltro(input: string) {
        const filtro: {
            search: string;
            user: string;
            dataInicial: string;
            dataFinal: string;
            group: string;
            userSort: string;
            groupSort: string;
            groupCreator: string;
        } = {
            search: extractCleanText(input),
            user: getFilterParam(input, "usuario"),
            dataInicial: '',
            dataFinal: '',
            group: getFilterParam(input, "comunidade"),
            userSort: '',
            groupSort: '',
            groupCreator: getFilterParam(input, "criador"),
        };

        const dataIni = getFilterParam(input, "data_inicial");
        if (dataIni) {
            const dataMatch = dataIni.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
            if (dataMatch) {
                const [_, dia, mes, ano] = dataMatch;
                filtro.dataInicial = `${ano}-${mes}-${dia}`;
            }
        }

        const dataFim = getFilterParam(input, "data_final");
        if (dataFim) {
            const dataMatch = dataFim.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
            if (dataMatch) {
                const [_, dia, mes, ano] = dataMatch;
                filtro.dataFinal = `${ano}-${mes}-${dia}`;
            }
        }

        // User sort
        if (hasFilterFlag(input, ':usuarios_mais_novos'))   filtro.userSort = 'newest';
        else if (hasFilterFlag(input, ':usuarios_mais_antigos')) filtro.userSort = 'oldest';
        else if (hasFilterFlag(input, ':apenas_verificados'))    filtro.userSort = 'verified_only';

        // Group sort
        if (hasFilterFlag(input, ':comunidades_mais_antigas'))   filtro.groupSort = 'oldest';
        else if (hasFilterFlag(input, ':mais_posts'))            filtro.groupSort = 'most_posts';
        else if (hasFilterFlag(input, ':mais_membros'))          filtro.groupSort = 'most_members';

        return filtro;
    }
      
    const handleSearch = async () => {
        if (loading) return;
        setLoading(true);
        setUsers(null);
        setPosts([]);
        setCommunities([]);
        setDataNotFound(false);

        const filtros = parseFiltro(termoSearch);
        const cleanText = filtros.search;
        const filterTokens = extractFilterTokens(termoSearch);
        const hasAnyFilter = filterTokens.length > 0;

        let text = "";

        if (typeSeach === "post") {
            if (!cleanText && !hasAnyFilter) {
                setLoading(false);
                return;
            }
            text = encodeURIComponent(termoSearch);
        } else if (typeSeach === "user") {
            if (!cleanText) {
                text = "default-user";
                const stored = localStorage.getItem("default-user");
                if (stored) {
                    try {
                        setUsers(JSON.parse(stored));
                    } catch (e) {}
                }
            } else {
                text = encodeURIComponent(cleanText);
            }
        } else if (typeSeach === "group") {
            if (!cleanText) {
                text = "default-group";
                const stored = localStorage.getItem("default-group");
                if (stored) {
                    try {
                        setCommunities(JSON.parse(stored));
                    } catch (e) {}
                }
            } else {
                text = encodeURIComponent(cleanText);
            }
        }

        try {
            const url = `${PACOCA_API_URL}/search?page=0&typeSeach=${typeSeach}&search=${text}&user=${filtros.user}&dataInicial=${filtros.dataInicial}&dataFinal=${filtros.dataFinal}&group=${filtros.group}&user_sort=${filtros.userSort}&group_sort=${filtros.groupSort}&group_creator=${encodeURIComponent(filtros.groupCreator)}&limit=${typeSeach === "post" ? 4 : LIMIT_REQUEST_FOLLOWERS}`;

            const response = await axios.get(url, {
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    "Authorization": `Bearer ${token}`
                }
            });

            const data = response.data;

            if (text === "default-group" && data?.communities?.length) {
                localStorage.setItem("default-group", JSON.stringify(data.communities));
            }

            if (text === "default-user" && data?.users?.length) {
                localStorage.setItem("default-user", JSON.stringify(data.users));
            }

            if (data.users) setUsers(data.users);
            if (data.posts) setPosts(data.posts);
            if (data.communities) setCommunities(data.communities);

            if (typeSeach === "user" && !data?.users?.length) {
                setDataNotFound(true);
            }
            if (typeSeach === "post" && !data?.posts?.length) {
                setDataNotFound(true);
            }
            if (typeSeach === "group" && !data?.communities?.length) {
                setDataNotFound(true);
            }
        } catch (err: any) {
            const messageError = errorMessage(err);
            setMessage(messageError, "error");
            console.error("Erro ao pesquisar: ", messageError);
            console.error("Erro ao pesquisar: ", err);
        } finally {
            setLoading(false);
            setLoadingTermo(false);
        }
    };

    const debouncedSetTermoSearch = useRef(
        debounce((value: string) => {
            setTermoSearch(value);
        }, 500)
    ).current;

    useEffect(() => {
        return () => {
            debouncedSetTermoSearch.cancel();
        };
    }, [debouncedSetTermoSearch]);

    useEffect(() => {
        handleSearch();
    }, [termoSearch, typeSeach]);

    useEffect(() => {
        if (users?.length || communities?.length || posts?.length) {
            setLoadingTermo(false);
        }
    }, [users, communities, posts]);

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const input = event.target;
        const cursorPos = input.selectionStart || 0;
        const inputValue = input.value;

        setTermoLimpo(inputValue);

        const currentFilters = extractFilterTokens(termo);
        const newCombinedTerm = combineSearchAndFilters(inputValue, currentFilters);

        setTermo(newCombinedTerm);
        debouncedSetTermoSearch(newCombinedTerm);

        const newParams = new URLSearchParams(searchParams);
        if (newCombinedTerm) {
            newParams.set("termo", newCombinedTerm);
        } else {
            newParams.delete("termo");
        }
        setSearchParams(newParams, { replace: true });

        setUsers([]);
        setCommunities([]);

        setTimeout(() => {
            input.setSelectionRange(cursorPos, cursorPos);
        }, 0);
    };

    const handleFilter = (text: string) => {
        const cleanText = extractCleanText(termo);
        let currentFilters = extractFilterTokens(termo);
        const isKeyValue = /^:[^=\s]+=\S*/.test(text);

        if (isKeyValue) {
            const [key, ...rest] = text.split("=");
            const value = rest.join("=");
            currentFilters = currentFilters.filter(t => !t.startsWith(`${key}=`));
            if (value && value.trim() !== "") {
                currentFilters.push(`${key}=${value.trim()}`);
                if (key === ":usuario") {
                    currentFilters = currentFilters.filter(t => t !== ":pacoca");
                }
            }
        } else {
            if (currentFilters.includes(text)) {
                currentFilters = currentFilters.filter(t => t !== text);
            } else {
                currentFilters.push(text);
                if (text === ":pacoca") {
                    currentFilters = currentFilters.filter(t => !t.startsWith(":usuario=") && t !== ":apenas_verificados");
                } else if (text === ":apenas_verificados") {
                    currentFilters = currentFilters.filter(t => t !== ":pacoca");
                }
            }
        }

        const newCombined = combineSearchAndFilters(cleanText, currentFilters);
        setTermo(newCombined);
    };
    
    const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === "Enter") {
            debouncedSetTermoSearch.cancel();
            setTermoSearch(termo);
            handleSearch();
        }
    };

    const onApply = () => {
        debouncedSetTermoSearch.cancel();
        setTermoSearch(termo);
        const newParams = new URLSearchParams(searchParams);
        if (termo) {
            newParams.set("termo", termo);
        } else {
            newParams.delete("termo");
        }
        setSearchParams(newParams, { replace: true });
        closeFilter();
    };

    const onClear = () => {
        const cleanText = extractCleanText(termo);
        setTermo(cleanText);
    };

    return (
        <>
            <Screen className="container-screen-search screen-search" title={t("generics.search")} >
                <Helmet>
                    <title>Paçoca - {t("generics.search")}</title>
                    <meta name="description" content={`Paçoca - Pesquise no paçoca!`} />
                    <meta name="keywords" content={`Paçoca, rede social brasileira, Pesquisa, pesquise, usuários}`} />
                    <meta name="author" content="Paçoca Inc." />
                    <meta property="og:title" content={`Paçoca - Pesquisa - Rede Social`} />
                    <meta property="og:description" content={`Paçoca - Pesquisa`} />
                    <meta property="og:image" content="/img/link-preview.png?v=1" />
                    <meta property="og:url" content={window.location.href} />
                    <meta property="og:type" content="website" />
                    <meta name="twitter:card" content="summary_large_image" />
                    <meta name="twitter:title" content={`Paçoca - Pesquisa - Rede Social`} />
                    <meta name="twitter:description" content={`Paçoca - Pesquise no paçoca`} />
                    <meta name="twitter:image" content="/img/link-preview.png?v=1" />
                </Helmet>
                <div>
                    <div className="d-flex container-search container-search-padding">
                        <input
                            id="input-search-screen"
                            className="form-control input-search input-search-screen"
                            type="text"
                            name="search"
                            placeholder={t("generics.search")}
                            aria-label="Search"
                            value={termoLimpo}
                            onChange={handleChange}
                            onKeyDown={handleKeyDown}
                            required
                        />
                        <button
                            onClick={(e) => openFilter(e)}
                            className="btn-search btn-search-screen input-search-screen-icon-menu-dark btn"
                            type="button"
                            title="Buscar"
                        >
                            <Filter color="#d3d3d3" />
                        </button>
                    </div>
                    <div className="row row row-fillter-search">
                        <button className={`btn col-notification btn-light all ${typeSeach == "user" ? "notification-type-active" : ""}`} onClick={() => changeTypeSearch("user")}>
                            <p>Usuários</p>
                        </button>
                        <button className={`btn col-notification btn-light mention ${typeSeach == "post" ? "notification-type-active" : ""}`} onClick={() => changeTypeSearch("post")}>
                            <p>Posts</p>
                        </button>
                        <button className={`btn col-notification btn-light comment ${typeSeach == "group" ? "notification-type-active" : ""}`} onClick={() => changeTypeSearch("group")}>
                            <p>Comunidades</p>
                        </button>
                        {currentEgg && (
                            <button className={`btn col-notification btn-light comment easter-egg`} onClick={currentEgg.action}>
                                {currentEgg.icon && (
                                    <img
                                        src={`/img/easter_eggs/${currentEgg.icon}`}
                                        alt="easter egg"
                                        style={{ width: 17, height: 17, marginRight: 5, marginTop: 2, marginLeft: -3 }}
                                    />
                                )}
                                <p>{termoLimpo}</p>
                            </button>
                        )}
                    </div>
                    
                    {coins.map(id => (
                        <MarioCoin key={id} id={id} onEnd={removeCoin} />
                    ))}

                    <PostList onCloseModals={onCloseModals} onOpenComments={(idPost) => { setShowModalComments(true); setIdPostSelected(idPost); }} onOpenLikes={(idPost) => { setShowModalLikes(true); setIdPostSelected(idPost); }} posts={posts} setPosts={setPosts} />
                    <ModalPostLikes idPostSelected={idPostSelected} show={showModalLikes} />
                    {window.innerWidth <= 850 ? <ModalCommentsBottom setOpen={setShowModalComments} open={showModalComments} idPostSelected={idPostSelected} /> : <ModalComments idPostSelected={idPostSelected} show={showModalComments} />}

                    {dataNotFound && typeSeach == "user" ? (
                        <div className="user-select-none row row-empty-comment">
                            <span className="span-empty">
                                <UserMinus className="icon-empty" />
                                <h3 className="w-100 text-center">{t("empty.users")}</h3>
                            </span>
                        </div>
                    ) : null}

                    {dataNotFound && typeSeach == "post" ? (
                        <div className="user-select-none row row-empty-comment">
                            <span className="span-empty">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" className="icon-empty bi bi-postcard-heart" viewBox="0 0 16 16">
                                    <path d="M8 4.5a.5.5 0 0 0-1 0v7a.5.5 0 0 0 1 0v-7Zm3.5.878c1.482-1.42 4.795 1.392 0 4.622-4.795-3.23-1.482-6.043 0-4.622ZM2.5 5a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1h-3Zm0 2a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1h-3Zm0 2a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1h-3Z" />
                                    <path d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4Zm2-1a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1H2Z" />
                                </svg>
                                <h3 className="w-100 text-center">{t("empty.posts")}</h3>
                            </span>
                        </div>
                    ) : null}

                    {dataNotFound && typeSeach == "group" ? (
                        <div className="user-select-none row row-empty-comment">
                            <span className="span-empty">
                                <Users className="icon-empty" />
                                <h3 className="w-100 text-center">{t("empty.communitys")}</h3>
                            </span>
                        </div>
                    ) : null}

                    {users?.map((user, index) => (
                        <UserSearch clasNameSearch="" clasImgAccount="img-list-chat" key={index} user={user} />
                    ))}

                    {communities?.map((community, index) => (
                        <div key={index} className="row-notification open-notification row-user row-search">
                            <img className="user-select-none col-1 img-account-search img-notification" src={getImagePathBucketPacoca(community.img)} onError={(e) => { e.currentTarget.src = "/img/img-placeholder.jpg"; }} />
                            <div className="col" style={{ paddingLeft: "5px", overflow: "hidden" }} onClick={() => navigate(`/comunidades/${community.id}`)}>
                                <h5 className="h5-name-search name-card-search-user" style={{ overflowWrap: "anywhere", whiteSpace: "nowrap", overflow: "hidden", marginBottom: "2px" }}>
                                    <Link className="name-search" style={{ marginRight: 5 }} to={`/comunidades/${community.id}`}>{community?.name}</Link>
                                </h5>
                                <p className="username-search" style={{ whiteSpace: "nowrap", overflow: "hidden" }}>{community?.description}</p>
                            </div>
                        </div>
                    ))}

                    <UserSearchLoadin loading={loading || loadingTermo} />
                </div>
            </Screen>

            {/* ── MOBILE: Bottom Sheet ────────────────────────── */}
            <BottomSheet
                open={isDropdownVisible}
                setOpen={setDropdownVisible}
                hasXClose
                disableDrag={false}
                snapPoints={[0, 1]}
                initialSnap={1}
                title={
                    <div className="sf-bs-header">
                        <span className="sf-bs-title">Filtros</span>
                    </div>
                }
            >
                <div className="sf-bs-content scroll-fino">
                    <FilterContent termo={termo} typeSeach={typeSeach} onFilter={handleFilter} onApply={onApply} onClear={onClear} />
                </div>
            </BottomSheet>

            {/* ── DESKTOP: Side panel ─────────────────────────── */}
            {panelRendered && (
                <>
                    <div
                        className={`sf-backdrop ${panelEntering ? "sf-backdrop-in" : ""}`}
                        onClick={closeFilter}
                    />
                    <div className={`sf-panel ${panelEntering ? "sf-panel-in" : ""}`} role="dialog">
                        <div className="sf-panel-header">
                            <span className="sf-panel-title">Filtros</span>
                            <button className="sf-panel-close" onClick={closeFilter} aria-label="Fechar">
                                <X size={18} />
                            </button>
                        </div>
                        <div className="sf-panel-scroll scroll-fino">
                            <FilterContent termo={termo} typeSeach={typeSeach} onFilter={handleFilter} onApply={onApply} onClear={onClear} />
                        </div>
                    </div>
                </>
            )}
        </>
    );
};

/* ─── FilterContent — defined OUTSIDE SearchScreen to keep stable identity ── */
interface FilterContentProps {
    termo: string;
    typeSeach: string;
    onFilter: (text: string) => void;
    onApply: () => void;
    onClear: () => void;
}

function FilterContent({ termo, typeSeach, onFilter, onApply, onClear }: FilterContentProps) {
    // post flags
    const isOldFirst     = hasFilterFlag(termo, ":antigo_primeiro");
    const isPacoca       = hasFilterFlag(termo, ":pacoca");
    const hasImage       = hasFilterFlag(termo, ":tem_imagem");
    const userValue      = getFilterParam(termo, "usuario");
    const groupValue     = getFilterParam(termo, "comunidade");

    // user flags
    const isUserNewest   = hasFilterFlag(termo, ":usuarios_mais_novos");
    const isUserOldest   = hasFilterFlag(termo, ":usuarios_mais_antigos");
    const isVerifiedOnly = hasFilterFlag(termo, ":apenas_verificados");

    // group flags
    const isGroupOldest  = hasFilterFlag(termo, ":comunidades_mais_antigas");
    const isMorePosts    = hasFilterFlag(termo, ":mais_posts");
    const isMoreMembers  = hasFilterFlag(termo, ":mais_membros");
    const creatorValue   = getFilterParam(termo, "criador");

    // mutual-exclusion helpers for sort flags
    const userSortFlags  = [":usuarios_mais_novos", ":usuarios_mais_antigos", ":apenas_verificados"];
    const groupSortFlags = [":comunidades_mais_antigas", ":mais_posts", ":mais_membros"];

    const toggleExclusive = (flag: string, group: string[]) => {
        const alreadyOn = hasFilterFlag(termo, flag);
        // turn off all others in the group first, then toggle this one
        group.filter(f => f !== flag).forEach(f => {
            if (hasFilterFlag(termo, f)) onFilter(f); // removes it
        });
        if (!alreadyOn) onFilter(flag);
    };

    return (
        <div className="sf-panel-body">

            {/* ═══ POSTS ═════════════════════════════════════════ */}
            {typeSeach === "post" && (
                <>
                    <div className="sf-section-label">Ordenação</div>

                    <div onClick={() => onFilter(":antigo_primeiro")} className={`sf-row ${isOldFirst ? "sf-row-active" : ""}`}>
                        <span className="sf-row-text">Posts antigos primeiro</span>
                        {isOldFirst && <CheckCircle className="sf-check" size={18} />}
                    </div>

                    <div className="sf-section-label">Conteúdo</div>

                    <div onClick={() => onFilter(":pacoca")} className={`sf-row ${isPacoca ? "sf-row-active" : ""}`} style={{ opacity: !userValue ? 1 : 0.45 }}>
                        <span className="sf-row-text">Posts do perfil oficial</span>
                        {isPacoca && <CheckCircle className="sf-check" size={18} />}
                    </div>

                    <div onClick={() => onFilter(":tem_imagem")} className={`sf-row ${hasImage ? "sf-row-active" : ""}`}>
                        <span className="sf-row-text">Apenas posts com imagens</span>
                        {hasImage && <CheckCircle className="sf-check" size={18} />}
                    </div>

                    <div className="sf-section-label">Filtrar por</div>

                    <div className={`sf-row sf-row-input ${userValue ? "sf-row-active" : ""}`} style={{ opacity: !isPacoca ? 1 : 0.45 }}>
                        <span className="sf-row-text sf-input-label">
                            Apenas do usuário
                            <input disabled={isPacoca} placeholder="nome ou nome de usuário" type="text" className="sf-input" value={userValue} onChange={(e) => onFilter(`:usuario=${e.target.value}`)} />
                        </span>
                        {Boolean(userValue) && <CheckCircle className="sf-check" size={18} />}
                    </div>

                    <div className={`sf-row sf-row-input ${groupValue ? "sf-row-active" : ""}`}>
                        <span className="sf-row-text sf-input-label">
                            Apenas da comunidade
                            <input placeholder="nome ou descrição da comunidade" type="text" className="sf-input" value={groupValue} onChange={(e) => onFilter(`:comunidade=${e.target.value}`)} />
                        </span>
                        {Boolean(groupValue) && <CheckCircle className="sf-check" size={18} />}
                    </div>
                </>
            )}

            {/* ═══ USUÁRIOS ══════════════════════════════════════ */}
            {typeSeach === "user" && (
                <>
                    <div className="sf-section-label">Ordenação</div>

                    <div onClick={() => toggleExclusive(":usuarios_mais_novos", userSortFlags)} className={`sf-row ${isUserNewest ? "sf-row-active" : ""}`}>
                        <span className="sf-row-text">Contas mais recentes primeiro</span>
                        {isUserNewest && <CheckCircle className="sf-check" size={18} />}
                    </div>

                    <div onClick={() => toggleExclusive(":usuarios_mais_antigos", userSortFlags)} className={`sf-row ${isUserOldest ? "sf-row-active" : ""}`}>
                        <span className="sf-row-text">Contas mais antigas primeiro</span>
                        {isUserOldest && <CheckCircle className="sf-check" size={18} />}
                    </div>

                    <div className="sf-section-label">Conteúdo</div>

                    <div onClick={() => toggleExclusive(":apenas_verificados", userSortFlags)} className={`sf-row ${isVerifiedOnly ? "sf-row-active" : ""}`}>
                        <span className="sf-row-text">Apenas usuários verificados</span>
                        {isVerifiedOnly && <CheckCircle className="sf-check" size={18} />}
                    </div>
                </>
            )}

            {/* ═══ COMUNIDADES ═══════════════════════════════════ */}
            {typeSeach === "group" && (
                <>
                    <div className="sf-section-label">Ordenação</div>

                    <div onClick={() => toggleExclusive(":comunidades_mais_antigas", groupSortFlags)} className={`sf-row ${isGroupOldest ? "sf-row-active" : ""}`}>
                        <span className="sf-row-text">Comunidades mais antigas primeiro</span>
                        {isGroupOldest && <CheckCircle className="sf-check" size={18} />}
                    </div>

                    <div onClick={() => toggleExclusive(":mais_posts", groupSortFlags)} className={`sf-row ${isMorePosts ? "sf-row-active" : ""}`}>
                        <span className="sf-row-text">Com mais posts primeiro</span>
                        {isMorePosts && <CheckCircle className="sf-check" size={18} />}
                    </div>

                    <div onClick={() => toggleExclusive(":mais_membros", groupSortFlags)} className={`sf-row ${isMoreMembers ? "sf-row-active" : ""}`}>
                        <span className="sf-row-text">Com mais membros primeiro</span>
                        {isMoreMembers && <CheckCircle className="sf-check" size={18} />}
                    </div>

                    <div className="sf-section-label">Filtrar por</div>

                    <div className={`sf-row sf-row-input ${creatorValue ? "sf-row-active" : ""}`}>
                        <span className="sf-row-text sf-input-label">
                            Criadas por usuário
                            <input placeholder="nome ou @usuario" type="text" className="sf-input" value={creatorValue} onChange={(e) => onFilter(`:criador=${e.target.value}`)} />
                        </span>
                        {Boolean(creatorValue) && <CheckCircle className="sf-check" size={18} />}
                    </div>
                </>
            )}

            {/* Actions */}
            <div className="sf-actions">
                <button onClick={onClear} className="btn btn-danger sf-btn-clear">
                    Limpar
                </button>
                <button onClick={onApply} className="btn btn-blue sf-btn-apply">
                    Aplicar
                </button>
            </div>
        </div>
    );
}

export default SearchScreen
